import React from 'react';
import PropTypes from 'prop-types';

import { I18n } from 'Locales';
import { ColumnView } from 'Containers';
import { QuickFilters, Table } from 'Components';
import { mockFunction, getEffectiveQuickFilters } from 'Helpers';
import { ALIGNMENT, CAMPAIGNS_TYPE, FILTERS, FONT_SIZE, PAGE_NAMES } from 'Constants';

const Commercial = ({
  adminDailyFigures = {},
  adminFilters = {},
  getAdminDailyFigures = mockFunction,
  transient = {},
  updateTransientProps = mockFunction,
  updateUserProps = mockFunction,
  userAdminFilters = {},
  userRole = '',
  view = 'campaignsview'
}) => {
  const { dailyFigures = {} } = adminDailyFigures;
  const { campaigns = [] } = dailyFigures;

  const { getAdminDailyFiguresLoading = false, filters = {} } = transient;

  const columns = [
    {
      name: I18n.t('admin:campaign'),
      field: 'name',
      headerAlign: ALIGNMENT.START,
      itemSize: FONT_SIZE.SMALL,
      width: '40%',
      sorting: true,
      sortingAction: getAdminDailyFigures
    },
    {
      name: I18n.t('admin:baInTheField'),
      field: 'trading',
      headerAlign: ALIGNMENT.CENTER,
      itemSize: FONT_SIZE.SMALL,
      itemAlign: ALIGNMENT.CENTER,
      width: '20%'
    },
    {
      name: I18n.t('admin:scoring'),
      field: 'scoring',
      headerAlign: ALIGNMENT.CENTER,
      itemSize: FONT_SIZE.SMALL,
      itemAlign: ALIGNMENT.CENTER,
      width: '20%'
    },
    {
      name: I18n.t('admin:sales'),
      field: 'sales',
      headerAlign: ALIGNMENT.CENTER,
      itemSize: FONT_SIZE.SMALL,
      itemAlign: ALIGNMENT.CENTER,
      width: '20%'
    }
  ];

  const effectiveQuickFilters = getEffectiveQuickFilters(
    userAdminFilters,
    adminFilters,
    'dailyFigures',
    CAMPAIGNS_TYPE.COMMERCIAL,
    view
  );

  return (
    <ColumnView>
      <QuickFilters
        filtersType={FILTERS.DAILY_FIGURES}
        fetchTableItems={getAdminDailyFigures}
        quickFilters={effectiveQuickFilters}
        role={userRole}
        transient={transient}
        updateTransientProps={updateTransientProps}
        updateUserProps={updateUserProps}
        view={PAGE_NAMES.CAMPAIGNS_VIEW}
      />

      <Table
        columns={columns}
        filters={filters}
        multipleSelection={false}
        processing={getAdminDailyFiguresLoading}
        requiresDataTransformation={false}
        rows={campaigns}
      />
    </ColumnView>
  );
};

Commercial.propTypes = {
  adminDailyFigures: PropTypes.object,
  adminFilters: PropTypes.object,
  getAdminDailyFigures: PropTypes.func,
  transient: PropTypes.object,
  updateTransientProps: PropTypes.func,
  updateUserProps: PropTypes.func,
  userAdminFilters: PropTypes.object,
  userRole: PropTypes.string,
  view: PropTypes.string
};

export default Commercial;
